module.exports = __webpack_public_path__ + "img/6.6b1e1920.svg";